enum AzureConfig {
  AZURE_AD_CLIENT_ID = '4cd7ecd7-fe52-4767-b1a5-faa15e6e27ea',
  AZURE_AD_AUTHORITY = 'https://login.microsoftonline.com/organizations',
  AZURE_AD_SCOPE = '4cd7ecd7-fe52-4767-b1a5-faa15e6e27ea/.default',
}

export { AzureConfig };
